import { protocolList, type ProtocolListType } from '@constants/protocol-list';
import { FC } from 'react';
import styles from './protocol-select.module.scss';
import radioIcon from '@assets/images/vault/radio.svg';
import radioCheckIcon from '@assets/images/vault/radio-check.svg';
interface OwnProps {
  protocolValue: ProtocolListType;
  onChangeProtocolValue(value: ProtocolListType): void;
}

const ProtocolSelect: FC<OwnProps> = ({ protocolValue, onChangeProtocolValue }) => {
  return (
    <div className={styles.wrapper}>
      {protocolList.map((item) => {
        return (
          <div
            className={styles.list}
            onClick={() => onChangeProtocolValue(item.label)}
            key={item.label}
          >
            <img src={protocolValue === item.label ? radioCheckIcon : radioIcon} data-icon />
            {item.icon && <img src={item.icon} className={styles.icon} />}
            <span>{item.name}</span>
          </div>
        );
      })}
    </div>
  );
};

export default ProtocolSelect;
